(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    function initialiseCardGalleries(root) {
    var container = root || document;

    container.querySelectorAll('.card-gallery').forEach(function (gallery) {
      var dots = gallery.querySelectorAll('.card-gallery-dot');
      var slideshow = gallery.querySelector('slideshow-component');

      if (!dots.length || !slideshow) return;

      function updateDots(index) {
        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
          dot.setAttribute('aria-selected', dotIndex === index ? 'true' : 'false');
        });
      }

      function showSlide(index, animate) {
        var wasDisabled = slideshow.getAttribute('disabled') === 'true';

        if (wasDisabled) {
          slideshow.removeAttribute('disabled');
        }

        if (typeof slideshow.select === 'function') {
          slideshow.select(index, undefined, {
            animate: animate !== false
          });
        } else {
          var slidesContainer = slideshow.querySelector(
            'slideshow-slides, [ref="scroller"]'
          );

          if (index === 0 && slidesContainer) {
            slidesContainer.scrollLeft = 0;
          }
        }

        if (wasDisabled) {
          setTimeout(function () {
            slideshow.setAttribute('disabled', 'true');
          }, 50);
        }

        updateDots(index);
      }

      /* Force toujours la photo 1 au chargement */
      showSlide(0, false);

      requestAnimationFrame(function () {
        showSlide(0, false);
      });

      setTimeout(function () {
        showSlide(0, false);
      }, 200);

      dots.forEach(function (dot, dotIndex) {
        if (dot.dataset.galleryDotInitialised === 'true') return;

        dot.dataset.galleryDotInitialised = 'true';

        dot.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();

          var targetIndex = parseInt(dot.dataset.index, 10);

          if (isNaN(targetIndex)) {
            targetIndex = dotIndex;
          }

          showSlide(targetIndex, true);
        });
      });

      if (gallery.dataset.swipeListenerInitialised !== 'true') {
        gallery.dataset.swipeListenerInitialised = 'true';

        slideshow.addEventListener('slideshow:select', function (event) {
          if (
            event.detail &&
            typeof event.detail.index !== 'undefined'
          ) {
            updateDots(Number(event.detail.index));
          }
        });
      }
    });
  }

  initialiseCardGalleries(document);

  document.addEventListener('shopify:section:load', function (event) {
    initialiseCardGalleries(event.target);
  });

  window.addEventListener('pageshow', function () {
    initialiseCardGalleries(document);
  });
  } catch(e) { console.error(e); }
})();

})();
